import { useNavigate } from 'react-router-dom';

export default function Header() {
    const navigate = useNavigate();

    return (
        <header className="w-full bg-white border-b border-gray-200">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
                <div className="flex items-center">
                    <img
                        src="https://www.synswi.com/logo.png"
                        alt="Synswi"
                        className="h-8 w-auto cursor-pointer"
                        onClick={() => navigate('/')}
                    />
                </div>
            </div>
        </header>
    );
}

